<!-- 店员 - 调入  帮忙 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="staffSearch">
            <div class="flex-row">
              <el-input placeholder="请输入店员手机号 / 姓名" v-model.trim="mobile" class="input-with-select" clearable></el-input>
              <el-button type="primary" class="ml10" @click="search">搜索店员</el-button>
            </div>
            <p class="mt10 infos" v-if="jobIdentity == 'recall'">温馨提示：点击调入可将门店临时帮忙调动到其他门店的店员调回</p> 
            <p class="mt10 infos" v-else>温馨提示：点击调入可将店员从本公司其他门店调动到本门店{{jobIdentity == "formal" ? '正式入职' : '临时帮忙'}}</p>
          </div>
          <div v-if="list.length > 0">
            <div class="staff_box flex-row" v-for="(item,index) in list" :key="index">
              <div class="box_left">
                <el-avatar size="large" :src="item.headImgUrl"></el-avatar>
              </div>
              <div class="box_right ml10">
                <div class="fb">{{item.staffName}} {{item.mobile}}</div>
                <div class="color666 align-items pt16 mb10">
                  <div>所在门店：{{item.shopName}}</div>
                  <div v-if="item.status != 'quit'">
                    <el-button type="primary" @click="changeFormal(item)" v-if="item.jobTemporaryFlag || item.jobFormalFlag">调入</el-button>
                  </div>
                </div>
                <div class="align-items color666">
                  <div>店员状态：<span class="jishi">{{item.statusCn}}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="temporarilyNoData">
            <img src="../../../assets/images/new/recharge.png" alt="">
            <div class="color999 fontSize16 mt20">暂无数据</div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button @click="back">取消</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      list: [],
      mobile: '',
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      jobIdentity: ''
    };
  },
  mixins: [minxin],
  components: {
    drawer
  },

  computed: {},

  created() {
    this.init();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.jobIdentity = org;
        console.log(org)
        if (org == "formal") {
          this.addEditTitle = "他店调入";
        } else if (org == "temporary") {
          this.addEditTitle = "临时帮忙";
        } else {
          this.addEditTitle = "店员调回";
        }
      });
    },
    search () {
      // mobile
      if (!this.mobile) return this.$message.error("请输入店员手机号/姓名")
      this.$api.get(this.$url.companyShopStaff.search, {keyword: this.mobile, transferType: this.jobIdentity}).then(res => {
        this.list = res;
      }).catch(error => {
        console.log("error: ", error);
      });
    },
    async changeFormal (item) {
      if (this.jobIdentity == 'formal') {
        let res = await this.$api.get(this.$url.companyStaffTransfer.check, { staffId: item.id })
        if (res && res == 'yes') {
          this.$confirm('该店员为4个月内新店员，调动可能会涉及承担介绍费等费用，请谨慎操作。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.changeFormalFunc(item)
          }).catch(() => {});
        } else if (res && res == 'no') {
          this.changeFormalFunc(item)
        }
      } else {
        this.changeFormalFunc(item)
      }
      
    },
    changeFormalFunc (item) {
      let msg = this.jobIdentity == 'formal' ? `是否调入，${item.staffName} ${item.mobile}，到本店正式入职？` : this.jobIdentity == 'temporary' ? `是否调入，${item.staffName} ${item.mobile}，到本店临时帮忙？`: `是否调回，${item.staffName} ${item.mobile}，到本门店？`;
      const h = this.$createElement;
      this.$msgbox({
        title: '调入店员',
        message: h('p', null,[
          h('div', {  }, msg)
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(action => {
        this.$api.get(this.$url.companyShopStaff.apply, {jobIdentity: this.jobIdentity,originalShopId: item.shopId, staffId: item.id}).then(res => {
          if (res) {
            this.addEditShow = false;
            this.$message.success("调动成功");
            this.$emit("change", true);
          }
        }).catch(error => {});
      });
    },
    handleChangeDrawer(val) {
      this.addEditShow = false;
    },
    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.demo-drawer__content, .demo-drawer__content > div {
  height: auto;
}
.pay-mains {
  padding: 0;
  // height: 100%;
  .staffSearch {
    padding: 16px;
  }
  /deep/ .el-avatar--large {
    width: 46px;
    height: 46px;
  }
  .infos {
    font-size: 14px;
    color: #F5A623;
  }
  .staff_box {
    // border: 1px solid #fff;
    margin: 0 20px 20px;
    padding: 20px;
    box-shadow: 0 0 10px #ccc;
    border-radius: 4px;
    .box_right {
      flex: 1;
    }
  }
  
}

</style>
